import api from './client';

export interface FleetHealthAlert {
  type: string;
  label: string;
}

export interface VehicleHealthEntry {
  vehicle_id: string;
  company_id: string;
  plate_number: string;
  brand: string;
  model: string;
  status: string;
  has_obd: boolean;
  latest_voltage: number | null;
  collapse_count_7d: number;
  critical_days_7d: number;
  ev_battery_percent: number | null;
  suspect_trips: number;
  stale_pending: number;
  last_seen: string | null;
  alert_level: 'critical' | 'warning' | 'ok';
  alerts: FleetHealthAlert[];
}

export interface FleetHealthData {
  total: number;
  critical_count: number;
  warning_count: number;
  healthy_count: number;
  generated_at: string;
  vehicles: VehicleHealthEntry[];
}

interface FleetHealthResponse {
  success: boolean;
  data: FleetHealthData;
}

export const fleetHealthApi = {
  /**
   * GET /api/fleet/health
   * Returns aggregated vehicle health alerts (super_admin only).
   */
  async getFleetHealth(): Promise<FleetHealthData> {
    const response = await api.get<FleetHealthResponse>('/api/fleet/health');
    return response.data.data;
  },
};
